import { useQuery } from "@tanstack/react-query";
import { useDataProvider } from "ra-core";

import type { SalesTool } from "../types";

/** Query key of the single bounded tools query shared by the library and the lead panel. */
export const SALES_TOOLS_QUERY_KEY = "sales_tools_library";

/** Upper bound of the one query; the catalogue is expected to stay in the low thousands. */
const SALES_TOOLS_LIMIT = 2000;

/**
 * One bounded fetch of the tools the current role may read (RLS decides; archived tools are
 * additionally filtered client-side because FakeRest does not emulate the RLS rule hiding them).
 */
export const useSalesTools = () => {
  const dataProvider = useDataProvider();
  return useQuery({
    queryKey: [SALES_TOOLS_QUERY_KEY],
    queryFn: async () =>
      (
        await dataProvider.getList<SalesTool>("sales_tools", {
          pagination: { page: 1, perPage: SALES_TOOLS_LIMIT },
          sort: { field: "title", order: "ASC" },
          filter: {},
        })
      ).data,
  });
};
